import gql from 'graphql-tag';

export const CREATE_CITY = gql`
  mutation CreateCity($city: CityInput!) {
    adminMutation { createCity(city: $city) {
      cityName
      stateId
      postalCode
      createdOn
      updatedOn
      createdBy
      updatedBy
    }
    }
  }
`;
export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($userId: String!, $newPassword: String!) {
    adminMutation { changePassword(userId: $userId, newPassword: $newPassword) {
      id
      userName
      email
      lockoutEnd
      lockoutEnabled
    }
    }
  }
`;

export const TOGGLE_USER_STATUS = gql`
mutation ToggleUserStatus($userId: String!, $lockoutEnabled: Boolean!) {
    adminMutation {
      toggleUserStatus(userId: $userId, lockoutEnabled: $lockoutEnabled) {
        id
      userName
      email
      lockoutEnd
      lockoutEnabled
      }
    }
  }
`;

export const ADD_ADMIN_USER = gql`
  mutation AddAdminUser($userName: String!, $email: String!, $password: String!, $firstName: String!, $lastName: String!) {
    adminMutation {
      addAdminUser(userName: $userName, email: $email, password: $password, firstName: $firstName, lastName: $lastName) {
        id
        userName
        email
        firstName
        lastName
        cTime
      }
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($product: ProductInput!) {
    createProduct(product: $product) {
      productId
      model
      productType
      productSource
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($productId: Int!, $product: ProductInput!) {
    updateProduct(productId: $productId, product: $product) {
      productId
      model
      productType
      productSource
      isSmart
      batteryComponentType
      cecEquipmentCategory
      inverterType
    }
  }
`;

export const BULK_CREATE_PRODUCTS = gql`
  mutation BulkCreateProducts($products: [ProductInput!]!) {
    bulkCreateProducts(products: $products) {
      rowIndex
      success
      model
      error
    }
  }
`;

/** Super-admin CSV import: same semantics as manufacturer bulk create, scoped by manufacturerId. */
export const ADMIN_BULK_CREATE_PRODUCTS = gql`
  mutation AdminBulkCreateProducts($manufacturerId: Int!, $products: [ProductInput!]!) {
    adminMutation {
      adminBulkCreateProducts(manufacturerId: $manufacturerId, products: $products) {
        rowIndex
        success
        model
        error
      }
    }
  }
`;

export const ADMIN_CREATE_PRODUCT = gql`
  mutation AdminCreateProduct($manufacturerId: Int!, $product: ProductInput!) {
    adminMutation {
      adminCreateProduct(manufacturerId: $manufacturerId, product: $product) {
        productId
        model
        productType
        productSource
        isSmart
        batteryComponentType
        cecEquipmentCategory
        inverterType
        manufacturerName
      }
    }
  }
`;

export const ADD_COMMON_NAME = gql`
  mutation AddCommonName($manufacturerId: Int!, $cerName: String!) {
    adminMutation {
      addCommonName(manufacturerId: $manufacturerId, cerName: $cerName) {
        nameId
        cerName
        manufacturerId
        isActive
      }
    }
  }
`;

export const DELETE_COMMON_NAME = gql`
  mutation DeleteCommonName($nameId: Int!, $manufacturerId: Int!) {
    adminMutation {
      deleteCommonName(nameId: $nameId, manufacturerId: $manufacturerId) {
        nameId
        cerName
        manufacturerId
        isActive
      }
    }
  }
`;

